const Cloudera = () => (
  <img alt="Cloudera logo" src="/img/customer-logos/cloudera-logo-white.svg" />
);

export default Cloudera;
